//#region src/core/ui/audio-track-radio-group/data.ts
const AudioTrackRadioGroupDataAttrs = {
	/** Current audio track value. */
	value: "data-audio-track",
	/** Present when audio track selection is disabled. */
	disabled: "data-disabled",
	/** Present when audio track selection is unavailable. */
	hidden: "data-hidden",
	/** Indicates audio track availability (`available` or `unavailable`). */
	availability: "data-availability"
};
//#endregion
export { AudioTrackRadioGroupDataAttrs };

//# sourceMappingURL=data.js.map